import { type BrowserOptions } from '@sentry/angular';
import { sentryEnvironmentForHost } from './sentry-environment';
import { type BrowserEventFilterOptions, keepBrowserEvent } from './sentry-events';

/** The `sentry` block of a frontend environment file. */
export type SentryBuildConfig = Readonly<{ enabled: boolean; dsn: string }>;

/**
 * The `Sentry.init` options of a browser app on this host, or null when Sentry must not start: the build turns it off,
 * or the host is not one of our deployments (local and agent builds, see {@link sentryEnvironmentForHost}).
 */
export function browserSentryOptions(
  config: SentryBuildConfig,
  hostname: string,
  filter: BrowserEventFilterOptions = {},
): BrowserOptions | null {
  if (!config.enabled) return null;
  const environment = sentryEnvironmentForHost(hostname);
  if (environment === null) return null;
  return {
    dsn: config.dsn,
    environment,
    beforeSend: (event, hint) => (keepBrowserEvent(event, hint, filter) ? event : null),
  };
}
